import request from "./request"
import Cookies from 'js-cookie'

// 微信登录
export function wxLogin(data) {
    return request({
        method: 'POST',
        url: `/wxconfig/wxLogin`,
        data
    })
}


